/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `REG` - Regular
* `ICD` - ICD
* `OTHER` - Other
 */
export type PortTypes = typeof PortTypes[keyof typeof PortTypes];


export const PortTypes = {
  REG: 'REG',
  ICD: 'ICD',
  OTHER: 'OTHER',
} as const;
